<template>
  <div class="loading-overlay">
    <slot />
    <div v-if="loading" class="loading-overlay__overlay">
      <spring-spinner
        v-if="showSpinner"
        :animation-duration="2000"
        :size="38"
        color="#2e84e0"
      />
    </div>
  </div>
</template>

<script>
import { SpringSpinner } from 'epic-spinners'

export default {
  name: 'loading-overlay',
  components: {
    SpringSpinner,
  },
  props: {
    loading: Boolean,
    showSpinner: Boolean,
  },
}
</script>

<style lang="scss" scoped>
  .loading-overlay {
    position: relative;
    min-width: 100%;

    &__overlay {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      background: rgba(255, 255, 255, 0.8);
    }
  }
</style>
